import { render, staticRenderFns } from "./calcSalary.vue?vue&type=template&id=35043224&scoped=true&"
import script from "./calcSalary.vue?vue&type=script&lang=js&"
export * from "./calcSalary.vue?vue&type=script&lang=js&"
import style0 from "./calcSalary.vue?vue&type=style&index=0&id=35043224&prod&lang=scss&scoped=true&"
import style1 from "./calcSalary.vue?vue&type=style&index=1&id=35043224&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35043224",
  null
  
)

export default component.exports